import { unstable_ClassNameGenerator as ClassNameGenerator } from '@mui/material/className';

ClassNameGenerator.configure(
	// Do something with the componentName
	// (componentName) => `mui-jss-${componentName}`,
	(componentName) => componentName?.toLowerCase().includes('grid') ? componentName : `mui-jss-${componentName}`,

);
